import client from '../../client';
import {
  CHANGE_FILTER
} from '../constants/filter';

export const changeFilter = newArgs => dispatch => {
  client
    .put('/user/dashboardFilters', newArgs)
    .then(res => {
      dispatch({
        type: CHANGE_FILTER,
        data: newArgs
      })
    })
}



// WEBPACK FOOTER //
// ./src/redux/actions/filter.js